import type { DeviceDto } from '@timato/shared';
import { useLiveQuery } from 'dexie-react-hooks';
import { api } from './api';
import { db } from '@/db/db';

const KEY = 'auth.devices';

/** Cache the device list so the timer can name the device a run started on, even between fetches. */
export async function cacheDevices(): Promise<DeviceDto[]> {
  const devices = await api<DeviceDto[]>('/v1/account/devices');
  await db.meta.put({ key: KEY, value: devices });
  return devices;
}

export const useCachedDevices = (): DeviceDto[] => (useLiveQuery(() => db.meta.get(KEY), [])?.value as DeviceDto[] | undefined) ?? [];
